import React__default from 'react';
import classnames from 'classnames';
import styles from './Link.module.css.js';

function Link({ disabled = false, target = "_blank", label, icon, iconPosition, onClick, size = "medium", href, rel, }) {
    const className = classnames(styles.Link, styles[`Link___${size}`], {
        [styles[`Link___disabled`]]: disabled,
    }, {
        [styles[`Link___withIcon___${iconPosition}`]]: icon !== undefined &&
            iconPosition !== undefined &&
            iconPosition !== "left",
    });
    const handleClick = (event) => {
        if (!onClick)
            return;
        event.preventDefault();
        onClick();
    };
    const attributes = {
        className,
        onClick: handleClick,
        target,
    };
    // If href is not provided, the link will be rendered as a button
    if (href) {
        attributes.href = href;
        if (rel) {
            attributes.rel = rel;
        }
    }
    else {
        attributes.tabIndex = 0;
        attributes.role = "button";
    }
    return (React__default.createElement("a", { ...attributes },
        icon,
        label));
}

export { Link };
//# sourceMappingURL=Link.js.map
